
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#D2D5D9"}}),_c('path',{staticClass:"shp1",attrs:{"fill-rule":"evenodd","d":"M22.68 15.2l-3.4 3.39a4.798 4.798 0 01-6.78 0c-.3-.29-.53-.63-.73-.97l1.58-1.58c.07-.08.16-.12.25-.17.11.38.3.73.6 1.02.93.94 2.45.94 3.39 0l3.39-3.39c.94-.94.94-2.46 0-3.4-.94-.93-2.45-.93-3.39 0l-1.21 1.21c-.98-.38-2.03-.48-3.06-.33l2.57-2.57a4.792 4.792 0 016.79 0 4.792 4.792 0 010 6.79zm-8.98 5.57l-1.2 1.21c-.94.94-2.46.94-3.4 0-.93-.94-.93-2.45 0-3.39l3.4-3.39a2.39 2.39 0 013.39 0c.29.28.49.64.59 1.01.1-.05.18-.09.26-.17l1.58-1.58c-.2-.34-.44-.67-.73-.96a4.792 4.792 0 00-6.79 0l-3.39 3.39a4.792 4.792 0 000 6.79 4.792 4.792 0 006.79 0l2.57-2.57c-1.03.15-2.09.05-3.07-.34z","fill":"#fff"}})])
          )
        }
      }
    